import Vue from 'vue';
import Tabs from "vue-material-tabs";

Vue.use(Tabs);
